"use client";
import AppLayout from "@/components/app/applayout";
import Discover from "@/components/home/discover";
import Faq from "@/components/home/faq";
import FeaturedProperties from "@/components/home/featured";
import Getintouch from "@/components/home/Getintouch";
import OurServices from "@/components/home/ourService";
import Whyinvest from "@/components/home/whyinvest";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { homeFaqData } from "@/util/data/homeFaqData";
import { pxToRem } from "@/util";

export default function Home() {
  const { classes } = styles();
  return (
    <AppLayout>
      <Box className={classes.container}>
        <Discover />
        <FeaturedProperties />
        <OurServices />
        <Whyinvest />
        <Faq faqData={homeFaqData} />
        <Getintouch />
      </Box>
    </AppLayout>
  );
}
const styles = makeStyles()(() => ({
  container: {
    display: "flex",
    flex: 1,
    minHeight: pxToRem(500),
    flexDirection: "column",
  },
}));
